/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum InfrastructureType {
    All,
    Local,
    Cloud,
}
